import React from 'react'

import { Row, Col, Portlet } from '_zari/core'

import IdDetraccionFormGroup from './formGroups/idDetraccion'
import IdRetencionFormGroup from './formGroups/idRetencion'
import IdAfectacionCompraFormGroup from './formGroups/idAfectacionCompra'
import IdAfectacionVentaFormGroup from './formGroups/idAfectacionVenta'
import UbicacionAlmacenamientoFormGroup from './formGroups/ubicacionAlmacenamiento'

const AfectacionesSection = ({
  values,
  setValues,
  errors,
  touched,
  isSubmitting,
  detracciones,
  retenciones,
  afectacionesCompras,
  afectacionesVentas,
  ubicacionesAlmacenamiento
}) => {
  return (
    <>
      <Portlet>
        <Portlet.Body noPadding>
          <Row>
            <Col md={6}>
              <IdDetraccionFormGroup
                values={values}
                setValues={setValues}
                iError={errors._idDetraccion}
                iTouched={touched._idDetraccion}
                fIsSubmitting={isSubmitting}
                detracciones={detracciones}
              />
              <IdRetencionFormGroup
                values={values}
                setValues={setValues}
                iError={errors._idRetencion}
                iTouched={touched._idRetencion}
                fIsSubmitting={isSubmitting}
                retenciones={retenciones}
              />
              <UbicacionAlmacenamientoFormGroup
                values={values}
                setValues={setValues}
                iError={errors._idUbicacionAlmacenamiento}
                iTouched={touched._idUbicacionAlmacenamiento}
                fIsSubmitting={isSubmitting}
                ubicaciones={ubicacionesAlmacenamiento}
              />
            </Col>
            <Col md={6}>
              <IdAfectacionCompraFormGroup
                values={values}
                setValues={setValues}
                iError={errors.afectacionCompra}
                iTouched={touched.afectacionCompra}
                fIsSubmitting={isSubmitting}
                afectacionesCompras={afectacionesCompras}
              />
              <IdAfectacionVentaFormGroup
                values={values}
                setValues={setValues}
                iError={errors.afectacionVenta}
                iTouched={touched.afectacionVenta}
                fIsSubmitting={isSubmitting}
                afectacionesVentas={afectacionesVentas}
              />
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default React.memo(AfectacionesSection)
